module.exports = __webpack_public_path__ + "static/media/Bigichev_main_preview.c7f2b58a.jpg";